<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill-rule="evenodd"
      d="M15 0L5 1.7v11c-.3-.2-.7-.3-1.2-.3-.6 0-1.3.3-1.9.7-.6.4-1 1-1 1.6 0 .4.2.7.4.9.4.3.8.4 1.2.4.6 0 1.4-.3 1.9-.7.6-.4 1-1 1-1.7V3l9.2-1.6v9.7c-.3-.2-.7-.3-1.2-.3-.6 0-1.3.3-1.9.7-.6.4-1 1-1 1.6 0 .4.2.7.4.9.3.2.6.3 1.1.3.6 0 1.4-.3 1.9-.7.6-.4 1-1 1-1.7L15 0z"
      clip-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  name: 'MusicIcon',
}
</script>
